const EUROPE_SELLER_HOST = "seller.eu.tiktok.com";

const GB_COMPATIBLE_HOSTS = new Set([
  "seller.eu.tiktokglobalshop.com",
  "seller.eu.tiktokshopglobalselling.com",
  EUROPE_SELLER_HOST,
]);

type LocationParts = {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
};

const getRegionFromSearch = (search: string): string | undefined => {
  const match =
    search.match(/shop_region=(\w+)/) || search.match(/region=(\w+)/);
  return match?.[1];
};

/**
 * Preserves the legacy GB-domain routing contract while keeping URL
 * construction independent from browser navigation.
 */
export const getRegionRedirectUrl = (
  { hostname, pathname, search, hash }: LocationParts,
  getDefaultRegion: () => string
): string | undefined => {
  const queryRegion = getRegionFromSearch(search);
  const shopRegion = queryRegion || getDefaultRegion();

  if (shopRegion !== "GB" || GB_COMPATIBLE_HOSTS.has(hostname)) {
    return undefined;
  }

  const nextSearch = queryRegion
    ? search
    : `${search}${search ? "&" : "?"}shop_region=${shopRegion}`;

  return `https://${EUROPE_SELLER_HOST}${pathname}${nextSearch}${hash}`;
};

export const getSellerLoginUrl = (
  hostname: string,
  useCurrentSellerHost: boolean
): string =>
  useCurrentSellerHost
    ? `https://${hostname}/account/login`
    : "https://seller.tiktok.com/";
